import { render, staticRenderFns } from "./DirectorPools.vue?vue&type=template&id=5b6d5e5b&"
import script from "./DirectorPools.vue?vue&type=script&lang=js&"
export * from "./DirectorPools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports